import { history } from "../reducers/configureStore";

const StoreConst = {
	CLEAR_STORE: "CLEAR_STORE"
};

const clearStore = () => {
	const store = require("../reducers").default;
	store.dispatch({ type: StoreConst.CLEAR_STORE });
	history.push("/");
};

export { clearStore, StoreConst };


// WEBPACK FOOTER //
// ./src/actions/StoreAction.js